import uuid from 'uuid';
import * as actionTypes from '../actions/actionTypes';

const initialState = {
  customerCallbackNumber: '',
  channel: '',
  vhtSegment: '',
  megaUseCase: '',
  megaUseCaseDescription: '',
  customerSessionId: uuid.v1(),
  maxCustomerWaitTime: 10,
  atlasUniversalId: '',
  createAppointmentResponse: {},
  callMeNowResponse: {
    state: 'idle', // "idle", "pending", "success", "failure"
    errorCode: 0,
    vhtSlots: [],
    currentTimezone: '',
    waitInMinutes: -1,
    earliestSlot: null,
  },
};

const callMeNowReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_ATLAS_ID:
      return {
        ...state,
        atlasUniversalId: action.atlasID,
      };
    case actionTypes.SET_CREATE_APPT_RESPONSE:
      return {
        ...state,
        createAppointmentResponse: action.createAppointmentResponse,
      };
    case actionTypes.SET_CALL_ME_NOW_RESPONSE:
      return {
        ...state,
        callMeNowResponse: action.callMeNowResponse,
      };
    default:
      return state;
  }
};

export default callMeNowReducer;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/reducers/CallMeNow.js